import React, { useState } from 'react';
import './manage-game-sidebar.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsProgress, faBell, faBriefcase, faBug, faCaretRight, faComments, faExchange, faFlagCheckered, faFunnelDollar, faGear, faGem, faGlobeAmericas, faHandshake, faHouse, faLink, faList, faListCheck, faMagicWandSparkles, faMagnifyingGlass, faPeopleGroup, faPeopleLine, faPiggyBank, faShop, faShoppingBag, faShoppingBasket, faShoppingCart, faSliders, faStore, faStoreAlt, faTicket, faTicketAlt, faTicketSimple, faTrophy, faUserSlash, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import BugModal from '@/components/layout-auth/feedback-modal/bug-modal.component';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import InfoLinks from '@/components/SHARED/info-links/info-links.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import Modal from '@/components/modal/modal.component';
import FeedbackModal from '@/components/layout-auth/feedback-modal/feedback-modal.component';
import { membershipRestrictions } from '@/utils/membershipRestrictions';

export function switchManagerMenu(e) {
  const items = document.getElementsByClassName('menu-item')
  for (let item of items) {
    item.classList.remove('active')
  }
  const selectedItems = document.getElementsByClassName(e);
  for (let selectedItem of selectedItems) {
    selectedItem.classList.add('active');
  }
}

const ManageGameSidebar = ({
  gameData,
  actionItems,
  gameElements,
  playerList,
  orgs,
  role
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const membership = useSelector(state => state.userData.membership);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [pendingActionItems, setPendingActionItems] = useState(0);
  const [pendingRealWorldItems, setPendingRealWorldItems] = useState(0);
  const [showSettingsDrop, setShowSettingsDrop] = useState(false);
  const [showMarketplaceDrop, setShowMarketplaceDrop] = useState(false);
  const [showGameInfoModal, setShowGameInfoModal] = useState(false);
  const [ displayCollaborators, setDisplayCollaborators ] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!gameData) { return; }

  }, [gameData])

  useEffect(() => {
    if (!role) return;
    if (
      role === 'owner' &&
      (
        orgs ||
        (
          membership && 
          membership.membership === 2
        )
      )
    ) {
      setDisplayCollaborators(true);
    } else {
      setDisplayCollaborators(false);
    }
  }, [role, orgs, membership])

  useEffect(() => {
    if (!gameElements) return;
    const count =
      Object.values(gameElements)
        .filter(e =>
          e.opt_itemType === 'realworld' &&
          e.status === 'active'
        ).length;

  }, [gameElements])

  useEffect(() => {
    if (!actionItems || !playerList || !gameElements) return;
    const pendingAI = Object.values(actionItems)
      .filter(i =>
        i.status === 'pending' &&
        i.type !== 'realworld' &&
        playerList[i.playerId] &&
        gameElements[i.elementId]
      ).length;
    setPendingActionItems(pendingAI);
    const pendingRW = Object.values(actionItems)
      .filter(i =>
        i.status === 'pending' &&
        i.type === 'realworld' &&
        playerList[i.playerId] &&
        gameElements[i.elementId]
      ).length;
    setPendingRealWorldItems(pendingRW);
  }, [actionItems, playerList, gameElements])

  useEffect(() => {
    if (
      location.pathname.includes('/marketplace') ||
      location.pathname.includes('/contributions') ||
      location.pathname.includes('/lottery')
    ) {
      setShowMarketplaceDrop(true);
    } else {
      setShowMarketplaceDrop(false);
    }
    if (location.pathname.includes('/settings')) {
      setShowSettingsDrop(true);
    } else {
      setShowSettingsDrop(false);
    }
  }, [location])

  useEffect(() => {
    if (showSettingsDrop) {
      const el = document.getElementById('menu-container');
      if (!el) return;
      el.style.scrollBehavior = "smooth"; // Enable smooth scrolling
      let timeout = setTimeout(() => {
        el.scrollTop += 300;
        clearTimeout(timeout);
      }, 250);
    }
  }, [showSettingsDrop])

  async function copyJoinCode() {
    try {
      await navigator.clipboard.writeText(`https://app.gamably.com/join/${gameData.joinCode}`);
    } catch (err) {
      setAlertMessage('Failed to copy the Join Code. Please try again.');
      return;
    }
    document.getElementById(`${gameData.joinCode}-tooltip`).style.visibility = 'visible';

    const timeout = setTimeout(() => {
      document.getElementById(`${gameData.joinCode}-tooltip`).style.visibility = 'hidden';
      timeout && clearTimeout(timeout);
    }, 2000);

  }

  return (
    <div className='manage-game-sidebar'>
      <div className='sidebar-container'>
        <div className='game-header'>
          <div className='image-div'>
            <ImageContainer 
              src={gameData.header}
              className={`header-image ${gameData.border_header}-border`} />
          </div>
          <div className='title' style={{ 'color': gameData.color }}>{gameData.gameName}</div>
          <button
            className='g-button tiny-btn'
            onClick={() => setShowGameInfoModal(true)}>
            View Game Info
          </button>
        </div>
        {
          (role === 'distributor') &&
          <div className='manage-menu-container' id='menu-container'>
            <div className='manage-game-menu'>
              {/* Home button */}

              <Link to={`/manage/${gameData.path}`}>
                <button
                  className={`g-button text-only menu-item ${location.pathname === `/manage/${gameData.path}` ?
                      'active' :
                      ''
                    }`} >
                  <FontAwesomeIcon
                    icon={faHouse}
                    className='menu-item-icon'
                    size='xl'
                  />
                  <span>Home</span>
                </button>
              </Link>

              {/* Players button */}
              <Link to={`/manage/${gameData.path}/players`}>
                <button
                  className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/players`) ?
                      'active' :
                      ''
                    }`} >
                  <FontAwesomeIcon
                    icon={faUsers}
                    className='menu-item-icon'
                    size='xl'
                  />
                  <span>Players</span>
                </button>
              </Link>

              {/* Rewards button */}

              <Link to={`/manage/${gameData.path}/distribute`}>
                <button
                  className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/distribute`) ?
                      'active' :
                      ''
                    }`} >
                  <FontAwesomeIcon
                    icon={faGem}
                    className='menu-item-icon'
                    size='xl'
                  />
                  <span>Distribute Rewards</span>
                </button>
              </Link>
              {/* Real World items button */}

              {
                (
                  gameElements &&
                  Object.values(gameElements)
                    .filter(e =>
                      e.type === 'item' &&
                      e.opt_itemType === 'realworld' &&
                      e.status === 'active'
                    ).length > 0
                ) &&
                <Link to={`/manage/${gameData.path}/realworlditems`}>
                  <button
                    className={`g-button text-only menu-item manage-menu-action-items 
                                            ${pendingRealWorldItems > 0 ?
                        'pending-items' :
                        ''}
                                            ${location.pathname.includes(`/manage/${gameData.path}/realworlddist`) ?
                        'active' :
                        ''
                      }`} >
                    <div className="notification-with-badge">
                      <FontAwesomeIcon
                        icon={faShoppingBag}
                        className='menu-item-icon'
                        size='xl'
                      />
                      {
                        (pendingRealWorldItems > 0) &&
                        <span className="badge">{pendingRealWorldItems}</span>
                      }
                    </div>
                    <span>Real World Dist.</span>
                  </button>
                </Link>
              }
              {/* Leaderboards button */}

              {
                (gameData.access.includes('leaderboards')) &&
                <Link to={`/manage/${gameData.path}/leaderboards`}>
                  <button
                    className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/leaderboards`) ?
                        'active' :
                        ''
                      }`} >
                    <FontAwesomeIcon
                      icon={faFlagCheckered}
                      className='menu-item-icon'
                      size='xl'
                    />
                    <span>Leaderboards</span>
                  </button>
                </Link>
              }
              {/* Explore data button */}
              <Link to={`/manage/${gameData.path}/activity`}>
                <div
                  className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/activity`) ?
                      'active' :
                      ''
                    }`}
                  onClick={() => navigate(`/manage/${gameData.path}/activity`)}
                >
                  <FontAwesomeIcon
                    icon={faGlobeAmericas}
                    className='menu-item-icon'
                    size='xl'
                  />
                  <span>Game Activity</span>
                </div>
              </Link>
            </div>
          </div>
        }
        {
          (role === 'owner' || role === 'manager') &&
          <div className='manage-menu-container' id='menu-container'>
            <div className='manage-game-menu'>

              {/* Home button */}
              <Link to={`/manage/${gameData.path}`}>
                <button
                  className={`g-button text-only menu-item ${location.pathname === `/manage/${gameData.path}` ?
                      'active' :
                      ''
                    }`} >
                  <FontAwesomeIcon
                    icon={faHouse}
                    className='menu-item-icon'
                    size='xl'
                  />
                  <span>Home</span>
                </button>
              </Link>

              {/* Players button */}
              <Link to={`/manage/${gameData.path}/players`}>
                <button
                  className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/players`) ?
                      'active' :
                      ''
                    }`}>
                  <FontAwesomeIcon
                    icon={faUsers}
                    className='menu-item-icon'
                    size='xl'
                  />
                  <span>Players</span>
                </button>
              </Link>

              {/* Teams button */}
              <Link to={`/manage/${gameData.path}/teams`}>
                <button
                  className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/teams`) ?
                      'active' :
                      ''
                    }`} >
                  <FontAwesomeIcon
                    icon={faPeopleGroup}
                    className='menu-item-icon'
                    size='xl'
                  />
                  <span>Teams</span>
                </button>
              </Link>

              {/* Action items button */}

              {
                (
                  gameElements &&
                  (
                    Object.values(gameElements).filter(e => e.type === 'item' && e.opt_itemType === 'inventory').length > 0 ||
                    Object.values(gameElements).filter(e => e.type === 'challenge').length > 0
                  )
                ) &&
                <Link to={`/manage/${gameData.path}/actionitems`}>
                  <button
                    className={`g-button text-only menu-item manage-menu-action-items 
                                            ${pendingActionItems > 0 ?
                        'pending-items' :
                        ''}
                                            ${location.pathname.includes(`/manage/${gameData.path}/actionitems`) ?
                        'active' :
                        ''
                      }`} >
                    <div className="notification-with-badge">
                      <FontAwesomeIcon
                        icon={faBell}
                        className='menu-item-icon'
                        size='xl'
                      />
                      {
                        (pendingActionItems > 0) &&
                        <span className="badge">{pendingActionItems}</span>
                      }
                    </div>
                    <span>Action Items</span>
                  </button>
                </Link>
              }

              {/* Real World items button */}

              {
                (
                  gameElements &&
                  playerList &&
                  Object.values(gameElements)
                    .filter(e =>
                      e.type === 'item' &&
                      e.opt_itemType === 'realworld' &&
                      e.status === 'active'
                    ).length > 0
                ) &&
                <Link to={`/manage/${gameData.path}/realworlddist`}>
                  <button
                    className={`g-button text-only menu-item manage-menu-action-items 
                                            ${pendingRealWorldItems > 0 ?
                        'pending-items' :
                        ''}
                                            ${location.pathname.includes(`/manage/${gameData.path}/realworlddist`) ?
                        'active' :
                        ''
                      }`}>
                    <div className="notification-with-badge">
                      <FontAwesomeIcon
                        icon={faShoppingBag}
                        className='menu-item-icon'
                        size='xl'
                      />
                      {
                        (pendingRealWorldItems > 0) &&
                        <span className="badge">{pendingRealWorldItems}</span>
                      }
                    </div>
                    <span>Real World Dist.</span>
                  </button>
                </Link>
              }

              {/* Manage elements button */}
              <Link to={`/manage/${gameData.path}/elements`}>
                <button
                  className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/elements`) ?
                      'active' :
                      ''
                    }`}
                  onClick={() => navigate(`/manage/${gameData.path}/elements`)}
                >
                  <FontAwesomeIcon
                    icon={faBriefcase}
                    className='menu-item-icon'
                    size='xl'
                  />
                  <span>Manage Elements</span>
                </button>
              </Link>

              {/* Marketplace button */}
              {
                (
                  gameData &&
                  gameData.access.includes('store')
                ) &&
                <>
                  <button
                    className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/marketplace`) ?
                        '' :
                        ''
                      }`}
                    onClick={() => setShowMarketplaceDrop(!showMarketplaceDrop)}
                  >
                    <FontAwesomeIcon
                      icon={faStore}
                      className='menu-item-icon'
                      size='xl'
                    />
                    <span>Marketplace</span>
                    <FontAwesomeIcon
                      icon={faCaretRight}
                      id='marketplace-drop-menu-caret'
                      className={
                        `menu-item-icon ${showMarketplaceDrop ?
                          'rotated' :
                          ''
                        }`
                      }
                    />
                  </button>
                  <div
                    className={`drop-container marketplace ${showMarketplaceDrop ? 'active' : ''
                      } ${
                        gameData.access.includes('pointOfSale') && 
                        !membershipRestrictions[membership.membership].blocked.includes('pointOfSale') ?
                          'plus1' :
                          ''
                      }`}
                    id='marketplace-drop-menu'
                  >
                    <div className='drop-menu'>
                      <Link to={`/manage/${gameData.path}/marketplace`}>
                        <button
                          className={
                            `g-button text-only drop-menu-item menu-item ${(
                              location.pathname.includes(`/manage/${gameData.path}/marketplace`) &&
                              !location.pathname.includes('/marketplace/')
                            ) ?
                              'active' :
                              ''
                            }`
                          } >
                          <FontAwesomeIcon
                            icon={faShoppingCart}
                            className='drop-menu-item-icon'
                            size='lg'
                          />
                          Game Store
                        </button>
                      </Link>
                      <Link to={`/manage/${gameData.path}/marketplace/purchases`}>
                        <button
                          className={
                            `g-button text-only drop-menu-item menu-item ${location.pathname.includes('/marketplace/purchases') ?
                              'active' :
                              ''}`
                          } >
                          <FontAwesomeIcon
                            icon={faShoppingBasket}
                            className='drop-menu-item-icon'
                            size='lg'
                          />
                          Purchases
                        </button>
                      </Link>
                      <Link to={`/manage/${gameData.path}/contributions`}>
                        <button
                          className={
                            `g-button text-only drop-menu-item menu-item ${location.pathname.includes('contributions') ?
                              'active' :
                              ''}`
                          } >
                          <FontAwesomeIcon
                            icon={faPiggyBank}
                            className='drop-menu-item-icon'
                            size='lg'
                          />
                          Contributions
                        </button>
                      </Link>
                      <Link to={`/manage/${gameData.path}/lottery`}>
                        <button
                          className={
                            `g-button text-only drop-menu-item menu-item ${location.pathname.includes('lottery') ?
                              'active' :
                              ''}`
                          } >
                          <FontAwesomeIcon
                            icon={faTicket}
                            className='drop-menu-item-icon'
                            size='lg'
                          />
                          Lotteries
                        </button>
                      </Link>
                      {
                        (
                          gameData.access.includes('pointOfSale') && 
                          !membershipRestrictions[membership.membership].blocked.includes('pointOfSale')
                        ) &&
                        <Link to={`/manage/${gameData.path}/marketplace/pos`}>
                          <button
                            className={
                              `g-button text-only drop-menu-item menu-item ${location.pathname.includes('marketplace/pos') ?
                                'active' :
                                ''}`
                            } >
                            <FontAwesomeIcon
                              icon={faStoreAlt}
                              className='drop-menu-item-icon'
                              size='lg'
                            />
                            Point of Sale
                          </button>
                        </Link>
                      }
                      {/* <button 
                                        className={
                                            `g-button text-only drop-menu-item menu-item disabled ${location.pathname.includes('tradeportal') ? 
                                            'active' : 
                                            ''}`
                                        } 
                                        onClick={() => navigate(`/manage/${gameData.path}/tradeportal`)}
                                    >
                                        <FontAwesomeIcon 
                                            icon={faExchange} 
                                            className='drop-menu-item-icon' 
                                            size='lg' 
                                        /> 
                                        Trade Portal
                                    </button> */}
                    </div>
                  </div>
                </>
              }

              {/* Leaderboards button */}

              {
                (gameData.access.includes('leaderboards')) &&
                <Link to={`/manage/${gameData.path}/leaderboards`}>
                  <button
                    className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/leaderboards`) ?
                        'active' :
                        ''
                      }`} >
                    <FontAwesomeIcon
                      icon={faFlagCheckered}
                      className='menu-item-icon'
                      size='xl'
                    />
                    <span>Leaderboards</span>
                  </button>
                </Link>
              }

              {/* Rewards button */}
              <Link to={`/manage/${gameData.path}/distribute`}>
                <button
                  className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/distribute`) ?
                      'active' :
                      ''
                    }`} >
                  <FontAwesomeIcon
                    icon={faGem}
                    className='menu-item-icon'
                    size='xl'
                  />
                  <span>Distribute Rewards</span>
                </button>
              </Link>

              {/* Explore data button */}
              <Link to={`/manage/${gameData.path}/activity`}>
                <div
                  className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/activity`) ?
                      'active' :
                      ''
                    }`} >
                  <FontAwesomeIcon
                    icon={faGlobeAmericas}
                    className='menu-item-icon'
                    size='xl'
                  />
                  <span>Game Activity</span>
                </div>
              </Link>

              {/* Settings button */}
              <div
                className={`g-button text-only menu-item ${location.pathname.includes(`/manage/${gameData.path}/settings`) ?
                    '' :
                    ''
                  }`}
                onClick={() => setShowSettingsDrop(!showSettingsDrop)}
              >
                <FontAwesomeIcon
                  icon={faGear}
                  className='menu-item-icon'
                  size='xl'
                />
                <span>Game Settings</span>
                <FontAwesomeIcon
                  icon={faCaretRight}
                  id='settings-drop-menu-caret'
                  className={
                    `menu-item-icon ${showSettingsDrop ?
                      'rotated' :
                      ''
                    }`
                  }
                />
              </div>
              <div
                className={`drop-container settings ${showSettingsDrop ? 'active' : ''
                  } ${displayCollaborators ? 'orgs' : ''
                  }`}
                id='settings-drop-menu'
              >
                <div className='drop-menu'>
                  <Link to={`/manage/${gameData.path}/settings`}>
                    <div
                      className={
                        `drop-menu-item menu-item ${location.pathname === (`/manage/${gameData.path}/settings`) ?
                          'active' :
                          ''
                        }`
                      } >
                      <FontAwesomeIcon
                        icon={faListCheck}
                        className='drop-menu-item-icon'
                        size='lg'
                      />
                      Information
                    </div>
                  </Link>
                  {
                    (displayCollaborators) &&
                    <Link to={`/manage/${gameData.path}/settings/collaborators`}>
                      <div
                        className={
                          `drop-menu-item menu-item ${location.pathname === (`/manage/${gameData.path}/settings/collaborators`) ?
                            'active' :
                            ''
                          }`
                        } >
                        <FontAwesomeIcon
                          icon={faHandshake}
                          className='drop-menu-item-icon'
                          size='lg'
                        />
                        Collaborators
                      </div>
                    </Link>
                  }
                  <Link to={`/manage/${gameData.path}/settings/design`}>
                    <div
                      className={
                        `drop-menu-item menu-item ${location.pathname.includes('settings/design') ?
                          'active' :
                          ''}`
                      } >
                      <FontAwesomeIcon
                        icon={faMagicWandSparkles}
                        className='drop-menu-item-icon'
                        size='lg'
                      />
                      Game Design
                    </div>
                  </Link>
                  <Link to={`/manage/${gameData.path}/settings/rostering`}>
                    <div
                      className={
                        `drop-menu-item menu-item ${location.pathname.includes('settings/rostering') ?
                          'active' :
                          ''}`
                      } >
                      <FontAwesomeIcon
                        icon={faPeopleLine}
                        className='drop-menu-item-icon'
                        size='lg'
                      />
                      Rostering
                    </div>
                  </Link>
                  <Link to={`/manage/${gameData.path}/settings/elements`}>
                    <div
                      className={
                        `drop-menu-item menu-item ${location.pathname.includes('settings/elements') ?
                          'active' :
                          ''}`
                      } >
                      <FontAwesomeIcon
                        icon={faSliders}
                        className='drop-menu-item-icon'
                        size='lg'
                      />
                      Element Options
                    </div>
                  </Link>
                  <Link to={`/manage/${gameData.path}/settings/removedPlayers`}>
                    <div
                      className={
                        `drop-menu-item menu-item ${location.pathname.includes('settings/removedplayers') ?
                          'active' :
                          ''}`
                      } >
                      <FontAwesomeIcon
                        icon={faUserSlash}
                        className='drop-menu-item-icon'
                        size='lg'
                      />
                      Removed Players
                    </div>
                  </Link>
                </div>
              </div>

              {/* Bug report button */}

              <button
                className='g-button text-only menu-item manage-menu-bug'
                onClick={() => setShowFeedbackModal(true)}>
                <FontAwesomeIcon
                  icon={faComments}
                  className='menu-item-icon'
                  size='xl'
                />
                <span>Send Us Feedback</span>
              </button>
            </div>
          </div>
        }
        {/* <div className="g-space-40"></div> */}
        <div className='manage-menu-footer'>
          <InfoLinks />
        </div>
      </div>
      <FeedbackModal
        show={showFeedbackModal}
        cancel={() => setShowFeedbackModal(false)}
      />
      <Modal
        show={showGameInfoModal}
        cancel={() => setShowGameInfoModal(false)}
        closeButton={true}
        text="Game Information"
      >
        <div className='join-code'>
          Join Code:
          <strong>{gameData.joinCode}</strong>
          <div className='g-tooltip'>
            <span
              className='g-tooltip-text'
              id={`${gameData.joinCode}-tooltip`}>Copied!
            </span>
            <button
              className='g-button small-btn'
              title='Copy Link to Join'
              onClick={() => copyJoinCode()}>
              <FontAwesomeIcon icon={faLink} />
            </button>
          </div>
        </div>
        <div className="g-space-1"></div>
        <div className='game-info-content'>
          <div dangerouslySetInnerHTML={{ __html: gameData.desc }} />
        </div>

      </Modal>
    </div>
  )
}

export default ManageGameSidebar